import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { PaymentMethodExceptionLimitDeleteRequestPayload } from '@/models/ps-management/exception-limit.model';

export default class DeletePaymentMethodExceptionLimitRequest extends ApiResourceMethod<{}> {
  public perform(payload: PaymentMethodExceptionLimitDeleteRequestPayload): Promise<{}> {
    return this.performer.requestWithMapper(
      { url: `paymentMethodSettings/${payload.paymentMethodSettingsId}/extendedLimit/${payload.exceptionLimitId}` },
      (response: BaseResponse<{}>): {} => {
        return response.data;
      },
    );
  }
}
